import { makeObservable, override } from 'mobx';
import type { PregnancyParams } from 'chaika-frontend-types/frontend-cms';
import { FieldStatus } from 'chaika-enums';

import { store } from '@store';
import { List } from '@store/abstract/List';

import { Pregnancy } from './Pregnancy';

export class PregnancyList extends List<Pregnancy, PregnancyParams> {
    constructor(pregnancyParams: PregnancyParams[]) {
        super();
        makeObservable(this);

        this.set(pregnancyParams);
    }

    @override
    public get ids(): string[] {
        return store.entry.isViewMode
            ? super.ids
            : this.serialize()
                  .filter(item => item.status !== FieldStatus.Deleted)
                  .map(item => item.id);
    }

    public serialize(): PregnancyParams[] {
        const pregnancyParams: PregnancyParams[] = [];

        this.list.forEach(pregnancy => {
            pregnancyParams.push(pregnancy.serialize());
        });

        return pregnancyParams;
    }

    protected create(params: PregnancyParams): Pregnancy {
        return new Pregnancy(params);
    }
}
